/** Live-verified copy (docs/spec/modules/projects-tasks.md "Live-verified"); default labels capitalised. */
export const s = {
  projects: "Projects",
  alerts: "Alerts",
  createNewProject: "Create new project",
  filter: "Filter",
  active: "Active",
  archived: "Archived",
  showAll: "Show all",
  client: "Client",
  access: "Access",
  billing: "Billing",
  billable: "Billable",
  nonBillable: "Non billable",
  findByName: "Find by name",
  applyFilter: "Apply filter",
  clearFilters: "Clear filters",
  export: "Export",
  saveAsCsv: "Save as CSV",
  saveAsExcel: "Save as Excel",
  colName: "Name",
  colClient: "Client",
  colTracked: "Tracked",
  colAmount: "Amount",
  colProgress: "Progress",
  colAccess: "Access",
  public: "Public",
  private: "Private",
  favoriteNotSelected: "Favorite Not Selected",
  favoriteSelected: "Favorite Selected",
  projectActions: "Project actions",
  edit: "Edit",
  setAsTemplate: "Set as template",
  dontUseAsTemplate: "Don't use as template",
  archive: "Archive",
  restore: "Restore",
  delete: "Delete",
  cancel: "Cancel",
  create: "Create",
  save: "Save",
  remove: "Remove",
  add: "Add",
  set: "Set",
  change: "Change",
  setRate: "Set rate",
  template: "Template",
  noProjectsYet: "No projects yet",
  noMatchingProjects: "No matching projects",
  noArchivedProjects: "No archived projects",
  selected: (n: number) => `${n} selected`,
  searchByName: "Search by name",
  withoutClient: "Without client",
  selectAll: "Select all",
  noClientsYet: "No clients yet",
  noMatchingClients: "No matching clients",
  filterUsersAndGroups: "Filter users and groups",
  users: "Users",
  groups: "Groups",
  // create modal
  createNewProjectTitle: "Create new Project",
  enterProjectName: "Enter Project name",
  selectClient: "Select client",
  noTemplate: "No template",
  color: "Color",
  visibleToAll: "Visible to all workspace members",
  projectCreated: "Project created",
  projectNameLength: "Project name has to be between 2 and 250 characters long",
  // archive / restore / delete
  archiveTitle: "Archive",
  restoreTitle: "Restore",
  deleteTitle: "Delete",
  archiveBody: (p: string) => `${p} won’t be available when tracking time.`,
  restoreBody: (p: string) => `${p} will be available when tracking time.`,
  alsoMarkDone: "Also mark all tasks as done",
  alsoMarkActive: "Also mark all tasks as active",
  deleteQuestion: (p: string) => `Are you sure you want to delete project ${p} ?`,
  deleteBody: (p: string) =>
    `The ${p} project will also be removed from all time entries and expenses it is assigned to. This action cannot be reversed.`,
  typeDelete: "Type DELETE to confirm",
  bulkArchiveTitle: (n: number) => (n === 1 ? "Archive 1 project" : `Archive ${n} projects`),
  bulkRestoreTitle: (n: number) => (n === 1 ? "Restore 1 project" : `Restore ${n} projects`),
  bulkDeleteTitle: (n: number) => (n === 1 ? "Delete 1 project" : `Delete ${n} projects`),
  bulkArchiveBody: "Selected projects won't be available when tracking time.",
  bulkRestoreBody: "Selected projects will become available when tracking time.",
  bulkDeleteQuestion: (n: number) => `Are you sure you want to delete ${n} projects?`,
  bulkDeleteBody:
    "Projects will also be removed from all time entries they are assigned to. This action cannot be reversed.",
  bulkUpdated: (n: number) => `Successfully updated ${n} projects.`,
  projectUpdated: "Project has been updated",
  projectUpdateFailed: "Failed to update the project, please try again.",
  noAccess: "You don't have access to this project.",
  // detail
  tabTasks: "Tasks",
  tabAccess: "Access",
  tabStatus: "Status",
  tabForecast: "Forecast",
  tabNote: "Note",
  tabSettings: "Settings",
  tabTitle: (name: string, tab: string) => `${name} - ${tab}`,
  // tasks tab
  showActive: "Show active",
  showDone: "Show done",
  addNewTask: "Enter task name",
  noTasksYet: "No tasks yet",
  noTasksSubtitle: "Add your first one and start tracking progress.",
  noCompletedTasks: "No completed tasks",
  noMatchingTasks: "No matching tasks",
  tasks: "Tasks",
  assignees: "Assignees",
  anyone: "Anyone",
  nUsers: (n: number) => `${n} users`,
  estimateH: "Estimate (h)",
  markAsDone: "Mark as done",
  markAsActive: "Mark as active",
  taskActions: "Task actions",
  taskAccessUpdated: "Task access updated.",
  taskExists: (n: string) => `${n} already exists`,
  deleteTaskBody: (t: string) =>
    `The ${t} task will also be removed from all time entries it is assigned to. This action cannot be reversed.`,
  taskNameInput: "Task name",
  // access tab
  visibility: "Visibility",
  visibilityPublicHelp: "Everyone can track time on public Projects.",
  visibilityPrivateHelp: "Only people you add to the Project can track time on it.",
  addMembers: "Add members",
  noMembersLeft: "No members left",
  role: "Role",
  owner: "Owner",
  admin: "Admin",
  projectManager: "Project manager",
  giveManagerRights: "Give manager rights",
  revokeManagerRights: "Revoke manager rights",
  memberActions: "Member actions",
  removeMemberBody: (n: string) =>
    `Once removed, ${n} will no longer have access to this project and won’t be able to track time for it any more.`,
  billableRate: (c: string) => `Billable rate (${c})`,
  costRate: (c: string) => `Cost rate (${c})`,
  // status tab
  tracked: "Tracked",
  timeEstimate: "Time estimate",
  projectBudget: "Project budget",
  remaining: "Remaining",
  overage: "Overage",
  nonBillableLabel: "Non-billable",
  withoutTask: "Without Task",
  hoursSpaced: (h: string) => `${h} h`,
  hoursTight: (h: string) => `${h}h`,
  ofHours: (h: string) => `of ${h}h`,
  // forecast
  forecastEmpty: "Forecast shows tracked and scheduled time against the estimate once scheduling data exists.",
  // note tab
  addNote: "Add note",
  notePlaceholder: "Add note...",
  noteHelp: "Learn how to format text and add links.",
  noteOver: (by: number, limit: number) => `You're over the limit by ${by} characters (max ${limit})`,
  // settings tab
  name: "Name",
  clientHelp: "Used for grouping similar Projects together.",
  colorHelp: "Use color to visually differentiate Projects.",
  billableByDefault: "Billable by default",
  billableByDefaultHelp: "All new entries on this project will be initially set as billable.",
  projectBillableRate: "Project billable rate",
  projectBillableRateHelp: "Billable rate used for calculating billable amount for this project.",
  projectCostRate: "Project cost rate",
  projectCostRateHelp: "Hourly rate used for calculating cost amount for this project.",
  projectEstimate: "Project estimate",
  projectEstimateHelp: "Choose how you wish to track Project progress (time or fixed fee budget).",
  noEstimate: "No estimate",
  manual: "Manual",
  taskBased: "Task based",
  includesNonBillable: "Estimate includes non-billable time",
  includesExpenses: "Budget includes billable expenses",
  resetEstimate: "Reset estimate every",
  week: "Week",
  month: "Month",
  year: "Year",
  addFieldsTitle: "Add additional fields",
  addFieldsHelp:
    "All time entries on this Project will have these fields. You can choose if users can see them and set their default value.",
  addMoreFields: "Add more fields...",
  noMoreFields: "No more available fields",
  toCreateMore: "To create more, go to workspace settings.",
  hUnit: "h",
  // alerts page
  alertsTitle: "Alerts",
  alertProject: "Project",
  alertTask: "Task",
  reaches: "reaches",
  ofEstimateAlert: "% of estimate, alert",
  deleteAlert: "Delete alert",
  deleteAlertBody: "Are you sure you want to delete this alert?",
  noAlerts: "No alerts yet",
  recipients: {
    WORKSPACE_ADMIN: "Workspace admin",
    PROJECT_MANAGER: "Project manager",
    PROJECT_MEMBERS: "Project members",
    TASK_ASSIGNEES: "Tasks assignees",
  },
  selectRecipients: "Select recipients",
  // picker
  searchProjectOrClient: "Search Project or Client",
  createNewProjectPicker: "Create new Project",
  favorites: "Favorites",
  nProjects: (n: number) => `${n} Projects`,
  project: "Project",
  noProject: "No project",
  projectSelect: "Select project",
} as const;
